import { Spinner, VStack } from "@gluestack-ui/themed";

export const CreditTableSearchLoading = () => {
  return (
    <VStack
      w="$full"
      h="$100vh"
      flex={1}
      alignItems="center"
      justifyContent="center"
    >
      <Spinner color="$primary700" />
    </VStack>
  );
};
